
import logo1 from '../saraswatiPuja/images/img-1.jpg';
import logo5 from '../yoga/yogaImages/img-2.jpg';
import logo6 from '../diwali/diwaliImages/img-6.jpg';
import logo7 from '../saraswatiPuja/images/img-7.jpg';
export default [
    {
      urls: logo1,
      title: "A Tribute to Maa Saraswati",
      description: "Saraswati Puja is a Sacred festival dedicated to Goddness Saraswati, symbol of knowledge",
    },
    {
      urls: logo5,
      title: "Harmony for Body and Mind",
      description: "Yoga is a timeless practice that harmonizes body, mind, and spirit",
    },
    {
      urls: logo6,
      title: "Festival of Lights and Renewal",
      description: "Diwali is a time of joyous festivities marked by the lighting of lamps",
    },
    {
      urls: logo7,
      title: "Vasant Panchami",
      description: "The festival is also a time for cultural programs, music, dance, and recitations",
    },
  ];